export const PROJECT_PROCESSING_STATUSES = new Set([
  'initiated',
  'uploaded',
  'pending',
  'parsing',
  'indexing',
  'processing',
])

export type ProjectItem = {
  id: string
  name: string
  description?: string | null
  is_personal?: boolean
  updated_at?: string
  created_at?: string
}

export type ProjectConversation = {
  id: string
  title: string
  last_message?: string | null
  updated_at?: string
  message_count: number
}

export type ProjectDoc = {
  id: string
  filename: string
  contract_id?: string | null
  scope?: string
  size_bytes?: number
  status?: string
  error_message?: string | null
  created_at?: string
}

export function formatProjectDate(value?: string): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function normalizeProjectLink(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}

export function validateProjectLink(value: string): string | null {
  const normalized = normalizeProjectLink(value)
  if (!normalized) return 'Введите ссылку'
  try {
    const parsed = new URL(normalized)
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return 'Поддерживаются только http/https ссылки'
    }
    if (!parsed.hostname) return 'Некорректный адрес'
    return null
  } catch {
    return 'Некорректный формат ссылки'
  }
}
